<div class="flex-header mat-dialog-title" translate>Change Password</div>
<div class="flex-content"
     [ngStyle]="{'overflow': 'unset','justify-content': 'center','align-items': IsChangePasswordUrl == false ? 'unset' : 'center' }">
    <div class="changePasswordAlert" *ngIf="User.ForceChangeExpiredPass || User.ForceChangePassword" translate>
        Current Password has expired
    </div>

    <tyl-form-field #currentPasswordRef label="Current Password" [ngStyle]="{'width': IsChangePasswordUrl == false ? '100%' : '450px'}">
        <input [(ngModel)]="currentPassword" matInput aria-label="Current Password" id="txtCurrentPassword" type="password"
        [required]="requiredCurrentPassword">
    </tyl-form-field>

    <tyl-form-field #newPasswordRef label="New Password" [ngStyle]="{'width': IsChangePasswordUrl == false ? '100%' : '450px'}">
        <input [(ngModel)]="newPassword" matInput aria-label="Current Password" id="txtNewPassword" type="password" required>
    </tyl-form-field>

    <tyl-form-field #repeatNewPasswordRef label="Repeat New Password" [ngStyle]="{'width': IsChangePasswordUrl == false ? '100%' : '450px'}">
        <input [(ngModel)]="repeatNewPassword" matInput aria-label="Current Password" id="txtRepeatNewPassword" type="password" required>
    </tyl-form-field>

</div>
<div class="flex-footer">
    <div class="flex-footer-right">
        <error-prompt [errorList]="errorList"></error-prompt>
        <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" translate></tyl-button>
        <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="closeClick()" translate></tyl-button>
    </div>
</div>





